import { RouteObject } from "react-router-dom";
import { TASKS_LIST_PATH, Tasks } from "./pages/tasks";
import { TASK_PATH, Task } from "./pages/task";
import {
  OVERDUE_TASKS_NOTIFICATION_SETTINGS_PATH,
  OverdueTasksNotificationSettingsPage,
} from "@/modules/tasks/pages/overdue-tasks-notification-settings";
import { TASKS_ADMIN_PATH, TasksAdmin } from "./pages/tasks-admin";
import { PROJECTS_PATH, Projects } from "./pages/projects";
import { MY_WORK_PATH, MyWork } from "./pages/my-work";
import { TASKS_CONTROL_PATH, TasksControl } from "./pages/tasks-control";

export const tasksRoutes: RouteObject[] = [
  {
    path: TASKS_LIST_PATH,
    element: <Tasks />,
  },
  {
    path: TASKS_ADMIN_PATH,
    element: <TasksAdmin />,
  },
  {
    path: PROJECTS_PATH,
    element: <Projects />,
  },
  {
    path: MY_WORK_PATH,
    element: <MyWork />,
  },
  {
    path: TASKS_CONTROL_PATH,
    element: <TasksControl />,
  },
  {
    path: TASK_PATH,
    element: <Task />,
  },
  {
    path: OVERDUE_TASKS_NOTIFICATION_SETTINGS_PATH,
    element: <OverdueTasksNotificationSettingsPage />,
  },
];
